import React from 'react';
import { XIcon, MinusIcon, PlusIcon, TrashIcon } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
export const Cart: React.FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({
  isOpen,
  onClose
}) => {
  const {
    state,
    dispatch
  } = useCart();
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" data-id="element-42">
      <div className="absolute right-0 top-0 h-full w-full max-w-md bg-black border-l border-red-600/20" data-id="element-43">
        <div className="p-4 flex justify-between items-center border-b border-red-600/20" data-id="element-44">
          <h2 className="font-display italic text-xl font-bold" data-id="element-45">Your Cart</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-46">
            <XIcon size={24} data-id="element-47" />
          </button>
        </div>
        <div className="p-4 flex-1 overflow-y-auto" data-id="element-48">
          {state.items.length === 0 ? <div className="text-center text-gray-400 mt-8" data-id="element-49">
              Your cart is empty
            </div> : <div className="space-y-4" data-id="element-50">
              {state.items.map(item => <div key={item.id} className="flex gap-4 p-4 bg-black/50 border border-red-600/20 rounded-xl" data-id="element-51">
                  <img src={item.image} alt={item.name} className="w-20 h-20 object-cover rounded-lg" data-id="element-52" />
                  <div className="flex-1" data-id="element-53">
                    <h3 className="font-display italic font-bold" data-id="element-54">
                      {item.name}
                    </h3>
                    <p className="text-sm text-gray-400" data-id="element-55">
                      {item.size && `Size: ${item.size}`}
                      {item.color && ` • Color: ${item.color}`}
                      {item.strain && ` • ${item.strain}`}
                    </p>
                    <div className="flex items-center justify-between mt-2" data-id="element-56">
                      <div className="flex items-center gap-2" data-id="element-57">
                        <button onClick={() => dispatch({
                    type: 'UPDATE_QUANTITY',
                    payload: {
                      id: item.id,
                      quantity: Math.max(0, item.quantity - 1)
                    }
                  })} className="p-1 hover:text-red-500" data-id="element-58">
                          <MinusIcon size={16} data-id="element-59" />
                        </button>
                        <span className="w-8 text-center" data-id="element-60">{item.quantity}</span>
                        <button onClick={() => dispatch({
                    type: 'UPDATE_QUANTITY',
                    payload: {
                      id: item.id,
                      quantity: item.quantity + 1
                    }
                  })} className="p-1 hover:text-red-500" data-id="element-61">
                          <PlusIcon size={16} data-id="element-62" />
                        </button>
                      </div>
                      <button onClick={() => dispatch({
                  type: 'REMOVE_ITEM',
                  payload: item.id
                })} className="text-gray-400 hover:text-red-500" data-id="element-63">
                        <TrashIcon size={18} data-id="element-64" />
                      </button>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-65">
                    <p className="font-bold" data-id="element-66">
                      ${(item.price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                </div>)}
            </div>}
        </div>
        <div className="p-4 border-t border-red-600/20" data-id="element-67">
          <div className="flex justify-between mb-4" data-id="element-68">
            <span data-id="element-69">Total</span>
            <span className="font-bold" data-id="element-70">${state.total.toFixed(2)}</span>
          </div>
          <Link to="/checkout" onClick={onClose} className={`font-display italic w-full bg-red-600 hover:bg-red-700 text-white py-3 px-6 rounded-full transition duration-300 text-center ${state.items.length === 0 ? 'opacity-50 cursor-not-allowed' : ''}`} disabled={state.items.length === 0} data-id="element-71">
            Proceed to Checkout
          </Link>
        </div>
      </div>
    </div>;
};